module.exports = __webpack_public_path__ + "img/4.9c7396b5.svg";